<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-12">
    <div>
      <b-input-group class="multi-input-form mb-3">
        <template v-slot:prepend>
          <b-dropdown text="Key" variant="">
            <b-dropdown-item v-for="propertyKey in PropertyKeys"
                             @click="property.key = propertyKey"
                             :key="propertyKey"
              >{{ propertyKey }}
            </b-dropdown-item>
          </b-dropdown>
        </template>
        <b-form-input
          :placeholder="property.key"
          v-model="property.value"
        ></b-form-input>

        <template v-slot:append>
          <b-input-group-append>
            <b-form-checkbox id="filter-input-1" class="mr-n2" v-model="property.forFilter">
              <span class="sr-only">Switch for following text input</span>
            </b-form-checkbox>
            <label for="filter-input-1">Add to filter</label>
          </b-input-group-append>
          <b-input-group-append>
            <b-form-checkbox id="filter-input-2" class="mr-n2" v-model="property.primaryFilter">
              <span class="sr-only">Switch for following text input</span>
            </b-form-checkbox>
            <label for="filter-input-2">Add to search</label>
          </b-input-group-append>
          <b-button variant="primary" @click="addToProperties(property)">
            <font-awesome-icon icon="plus"></font-awesome-icon>
          </b-button>
        </template>
      </b-input-group>
      <b-form-invalid-feedback id="error-div-1" v-if="propError && !property.key" style="display: block">
        <small>Choose A Key Value</small>
      </b-form-invalid-feedback>
      <b-form-invalid-feedback id="error-div-2" v-if="propError && property.key && !property.value" style="display: block">
        <small>Text Field is Empty</small>
      </b-form-invalid-feedback>
        <b-form-invalid-feedback id="error-div-2" v-if="propError && property.key && property.value && property.value.length > 15" style="display: block">
            <small>Property Value should not exceed 15 Characters</small>
        </b-form-invalid-feedback>
      <b-form-invalid-feedback id="error-div-2" v-if="propError && property.key && property.value" style="display: block">
        <small>Video Properties Should not be Empty.click + button to continue</small>
      </b-form-invalid-feedback>
    </div>
    <div>
      <div class="multi-form-list">
        <div v-for="(prop, index) in propertyList" class="multi-form-list-item">
          <div class="deets">
            <span class="fii">{{ prop.key }} - {{ prop.value }}</span>
            <div class="isit">
              <span v-if="prop.forFilter">In filter</span>
              <span v-if="prop.primaryFilter">In search</span>
            </div>
          </div>
          <b-btn
            variant="primary"
            class="btn-1 m-1"
            @click="removeFromCourseProperties(index)"
          >
            <font-awesome-icon icon="times"></font-awesome-icon>
          </b-btn>
          <b-btn
            variant="primary"
            class="btn-2"
            @click="editCourseProperties(prop, index)"
          >
            <font-awesome-icon :icon="['far', 'edit']" />
          </b-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "property-template",
  data() {
    return {
      property: {
        key: "",
        forFilter: false,
        primaryFilter: false,
        value: ""
      },
      propertyList: [],
      propError: false
    };
  },
  methods: {
    addToProperties(prop) {
      if (this.showError && prop.key === "" || prop.value === "" || prop.value.length > 15) {
        this.propError = true;
      } else {
        this.propError = false;
        if (this.propertyList.some(pro => pro.key === prop.key)) {
          const index = this.propertyList.findIndex(pro => {
            return pro.key === prop.key;
          });
          this.propertyList.splice(index, 1);
          this.propertyList.push(prop);
        } else {
          this.propertyList.push(prop);
        }
        this.property = {
          key: "",
          value: "",
          addToFilter: false,
          addToPrimary: false
        };
        this.updateProperties();
      }
    },
    removeFromCourseProperties(index) {
      this.propertyList.splice(index, 1);
      this.updateProperties();
    },
    editCourseProperties(prop, index) {
      this.property = prop;
      this.propertyList.splice(index, 1);
      this.updateProperties();
    },
    updateProperties() {
      this.$emit("updateProperties", this.propertyList);
    }
  },
  props: {
    PropertyKeys: Array,
    showError: Boolean,
    showPropError: Boolean,
    properties: Array
  },
  watch: {
    showError() {
      if (this.showError && this.showPropError) {
        this.propError = true;
      }
    },
    properties() {
      this.propertyList = this.properties ? this.properties : [];
    }
  }
};
</script>

<style scoped></style>
